import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Rollbar } from '@app-masters/js-lib';
import { ACTIONS } from '../actions/actionTypes';
import Checkbox from './components/checkbox';
import Spinner from './components/spinner';

class CourseSelectView extends Component {
    constructor (props) {
        super(props);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    componentDidMount () {
        try {
            const affinity = this.props.user.data.affinity.sort((a, b) => (b.percentage - a.percentage));
            let userAffinityAreas = affinity.filter(aff => aff.areaTitle !== 'Enem').map(item => item.area);
            userAffinityAreas = userAffinityAreas.slice(0, 3);
            this.props.getCourses(userAffinityAreas);
            this.props.cleanSelectedInput();
        } catch (error) {
            Rollbar.error(new Error('User without affinity at courseSelectView.js'), 'user not found in localStorage at ranking.js', error);
            window.alert('Houve um erro inesperado e os programadores responsáveis já foram avisados.');
            this.props.push('/');
        }
    }

    handleCheckboxChange (checked) {
        this.props.selectCourse(checked);
        this.forceUpdate();
    }

    handleRadioChange (selected) {
        this.props.setGraduatedCourse([selected]);
    }

    onSave (key) {
        let user = this.props.user;
        user.data.academicRecords[key] = this.props.selectedCourses;
        this.props.updateUser(user);
        // setTimeout(() => { this.props.push('/'); }, 3000);
        this.props.push('/');
    }

    renderContent () {
        if (this.props.loading || !this.props.courses) {
            return (
                <Spinner />
            );
        }
        let key = '';
        let options = [];
        let maxCheck = 0;
        switch (this.props.match.params.level) {
        case 'monitor':
            key = 'monitor';
            options = this.props.courses;
            maxCheck = 2;
            break;
        case 'graduation':
            key = 'graduated';
            options = this.props.courses;
            maxCheck = 1;
            break;
        case 'master':
            key = 'master';
            // get courses of the area he graduated
            options = this.props.courses;
            maxCheck = 1;
            break;
        case 'doctor':
            key = 'doctor';
            options = this.props.courses;
            maxCheck = 1;
            break;
        case 'professor':
            key = 'professor';
            options = this.props.courses;
            maxCheck = 1;
            break;
        default:
            console.error('Invalid Params');
            this.props.history.push('/');
            break;
        }
        return [
            <div style={{marginTop: 6}} key={'body'}>
                <Checkbox options={options} checked={this.props.selectedCourses}
                          onChange={(selected) => this.handleCheckboxChange(selected)} maxCheck={maxCheck} />
            </div>,
            <div className='ranking-button-wrapper' key={'button'}>
                <div className='btn flat current' onClick={() => this.onSave(key)}>Continuar</div>
            </div>
        ];
    }

    renderTitle () {
        if (this.props.match.params.level === 'monitor') {
            return 'Cursos para monitoria - Selecione até dois Cursos';
        } else if (this.props.match.params.level === 'graduation') {
            return 'Cursos de graduação - Selecione um Curso';
        } else if (this.props.match.params.level === 'master') {
            return 'Cursos de mestrado - Selecione um Curso';
        } else if (this.props.match.params.level === 'doctor') {
            return 'Cursos de doutorado - Selecione um curso';
        } else if (this.props.match.params.level === 'professor') {
            return 'Cursos de professor - Selecione um curso';
        }
    }

    render () {
        return (
            <div className='browser ranking'>
                <div className='fixed'>
                    <div className='window-buttons'>
                        <div onClick={() => this.props.push('/')}
                             className='btn-circle'
                        />
                        <div onClick={() => this.props.push('/')}
                             className='btn-circle'
                        />
                        <div onClick={() => this.props.push('/')}
                             className='btn-circle'
                        />
                    </div>
                    <div className='browser-address-bar padding'>
                        <span className='rounded-input'>{this.renderTitle()}</span>
                    </div>
                </div>
                <div style={{marginTop: 6}}>
                    {this.renderContent()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({user, courseReducer}) => ({
    user: user.user,
    selectedCourses: courseReducer.selectedCourses,
    courses: courseReducer.courses,
    loading: courseReducer.loading
});

const mapDispatchToProps = (dispatch) => ({
    updateUser: (input) => dispatch({type: ACTIONS.USER_UPDATE_REMOTE_DATA, payload: input}),
    push: (url) => dispatch(push(url)),
    getCourses: (areas) => dispatch({type: ACTIONS.GET_COURSES, payload: areas}),
    cleanSelectedInput: () => dispatch({type: ACTIONS.COURSE_CLEAN_SELECTION}),
    selectCourse: (courses) => dispatch({type: ACTIONS.COURSE_SELECTED_COURSES, payload: courses}),
    setGraduatedCourse: (course) => dispatch({type: ACTIONS.USER_SET_GRADUATED_COURSE, payload: course})
});

export default connect(mapStateToProps, mapDispatchToProps)(CourseSelectView);



// WEBPACK FOOTER //
// ./src/views/courseSelectView.js